import { render, staticRenderFns } from "./InternshipPosi.vue?vue&type=template&id=19c3b5eb&scoped=true"
import script from "./InternshipPosi.vue?vue&type=script&lang=js"
export * from "./InternshipPosi.vue?vue&type=script&lang=js"
import style0 from "./InternshipPosi.vue?vue&type=style&index=0&id=19c3b5eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c3b5eb",
  null
  
)

export default component.exports